import React from 'react';

import classnames from 'clsx';
import PropTypes from 'prop-types';

import { noop } from 'ui-components/default-props/noop';

import { FormattedMessagePropType } from '../../../prop-types/intl';
import { useOtherShippingOptionsStyleContext } from '../style-provider';
import OtherShippingOptionsFormOption from './form-option';

import style from './other-shipping-options-form.module.less';
import { emptyArray, emptyObject } from 'ui-components/default-props/empty';

const OtherShippingOptionsFormSection = ({
  title,
  sectionOptions = emptyArray,
  fulfillmentPlanId,
  onOptionUpdated = noop,
  onInputUpdated = noop,
  optionData = emptyObject,
  handleCheck = noop,
  sellerLabelProviderId = null,
}) => {
  const { classes } = useOtherShippingOptionsStyleContext();

  const options = sectionOptions.map((option, i) => {
    const dataForOption = optionData?.[option.optionName];

    if (!dataForOption) {
      return null;
    }

    return (
      <OtherShippingOptionsFormOption
        key={`${option.id}-${i}`}
        fulfillmentPlanId={fulfillmentPlanId}
        handleCheck={handleCheck}
        isChecked={dataForOption.checked}
        onInputUpdated={onInputUpdated}
        onOptionUpdated={onOptionUpdated}
        option={option}
        optionData={optionData}
        sellerLabelProviderId={sellerLabelProviderId}
        value={dataForOption.value}
      />
    );
  });

  if (options.some((option) => option !== null)) {
    return (
      <div className={classnames(style['option-section'], classes.optionSection)}>
        <div className={classnames(style['section-title'], classes.sectionTitle)}>{title}</div>
        {options}
      </div>
    );
  }

  return null;
};

export default OtherShippingOptionsFormSection;

OtherShippingOptionsFormSection.propTypes = {
  title: FormattedMessagePropType,
  sectionOptions: PropTypes.array,
  optionData: PropTypes.object,
  fulfillmentPlanId: PropTypes.string,
  onOptionUpdated: PropTypes.func,
  onInputUpdated: PropTypes.func,
  handleCheck: PropTypes.func,
  sellerLabelProviderId: PropTypes.string,
};
